"use strict";
function getPortalRoot(id) {
  if (typeof document === "undefined")
    return;
  const getPortalRoot2 = document.getElementById(id);
  if (!getPortalRoot2) {
    const rootElement = document.createElement("div");
    rootElement.setAttribute("id", id);
    return document.body.appendChild(rootElement);
  }
  return getPortalRoot2;
}
export default getPortalRoot;
